import { c as _c } from "react/compiler-runtime";
import { utc } from '@date-fns/utc';
import { format, parseISO } from 'date-fns';
interface BudgetStatementLastUpdateProps {
  lastModifiedAtUtcIso?: string | null;
}
function BudgetStatementLastUpdate(t0) {
  const $ = _c(16);
  const {
    lastModifiedAtUtcIso
  } = t0;
  if (!lastModifiedAtUtcIso) {
    return null;
  }
  let formatted;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== lastModifiedAtUtcIso) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const date = parseISO(lastModifiedAtUtcIso);
      if (Number.isNaN(date.getTime())) {
        t5 = null;
        break bb0;
      }
      formatted = `${format(date, "dd-MMM-yyyy HH:mm", {
        in: utc
      })} UTC`;
      t3 = "flex flex-col items-end";
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <span className="text-foreground text-xs/4.5 font-medium">LAST UPDATE</span>;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      t1 = "text-foreground/50 text-xs/4.5 font-normal";
      t2 = date.toISOString();
    }
    $[0] = lastModifiedAtUtcIso;
    $[1] = formatted;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    formatted = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[8] !== formatted || $[9] !== t1 || $[10] !== t2) {
    t6 = <time className={t1} dateTime={t2}>{formatted}</time>;
    $[8] = formatted;
    $[9] = t1;
    $[10] = t2;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
export { BudgetStatementLastUpdate };